import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class KnowledgeShareCollectApi extends NewviewOaBaseApi {

  public get ControllerName(): any {
    return 'knowledgeshare-collect'
  }

}